export default __webpack_public_path__ + "static/illustration-action-one.url-de6f500857dd5644dc0086c9eb4ead02.svg";